import { render, staticRenderFns } from "./dhlist.vue?vue&type=template&id=59923128&scoped=true&"
import script from "./dhlist.vue?vue&type=script&lang=js&"
export * from "./dhlist.vue?vue&type=script&lang=js&"
import style0 from "./dhlist.vue?vue&type=style&index=0&id=59923128&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59923128",
  null
  
)

export default component.exports